import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppUser } from '@classes/auth/infosUser';
import { NavLinks } from '@classes/navlinks/navlinks';
import { faCar } from '@fortawesome/free-solid-svg-icons';
import { DataService } from '@services/data/data.service';
import { SubscriptionBaseComponent } from 'app/shared/subscription-base/subscription-base';

@Component({
  selector: 'app-smartparking-home',
  templateUrl: './smartparking-home.component.html',
  styleUrls: ['./smartparking-home.component.scss']
})
export class SmartparkingHomeComponent extends SubscriptionBaseComponent implements OnInit {

  faCar = faCar;

  userAppSelected: AppUser;

  constructor(
    private dataService: DataService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.dataService.appName.next('SmartParking');
    this.dataService.logoApp.next(faCar);
    this.initSub();
  }



  private initSub(): void {
    this.subscription
      .add(
        this.dataService.userAppSelected.subscribe({
          next: userAppSelected => { this.userAppSelected = userAppSelected; this.cdr.detectChanges(); }

        })
      );
  }

}
